import { Logger } from '../utilities/logger';
import A11yDialog from 'a11y-dialog';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { AbstractComponent } from './abstract-component';
/**
 * Base for a modal window.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class Modal extends AbstractComponent {
    constructor(api, container) {
        var _a;
        super(api, container);
        Logger.debug('modal', 'Starting to construct.');
        const document = this.container.querySelector(':scope > [role="document"]');
        if (!document) {
            throw new Error('Document container missing.');
        }
        this.document = document;
        this.dialog = new A11yDialog(this.container);
        // Determine scroll target
        const scrollTarget = (_a = document.querySelector('[data-a11y-consent-scroll]')) !== null && _a !== void 0 ? _a : document;
        this.dialog.on('show', () => {
            Logger.info('modal', 'Show.');
            this.emitter.emit('show', this);
            disableBodyScroll(scrollTarget);
        });
        this.dialog.on('hide', () => {
            Logger.info('modal', 'Hide.');
            this.emitter.emit('hide', this);
            enableBodyScroll(scrollTarget);
        });
        Logger.debug('modal', 'Finished constructing.');
    }
    /**
     * Shows the modal. Basically a shortcut for calling `show()` of the `a11y-dialog` dialog.
     */
    show() {
        this.dialog.show();
    }
    /**
     * Hides the modal. Basically a shortcut for calling `hide()` of the `a11y-dialog` dialog.
     */
    hide() {
        this.dialog.hide();
    }
}
